import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_35_15071)"
};
const _hoisted_3 = ["fill"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_35_15071"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "18",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_center_wrapper = _resolveComponent("center-wrapper");
  return _openBlock(), _createBlock(_component_center_wrapper, null, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock("svg", {
      width: $props.width,
      height: $props.height,
      viewBox: `0 0 ${$props.width} ${$props.height}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.25 14.25H3.75V3.75H9V2.25H3.75C2.9175 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.9175 15.75 3.75 \n                    15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V9H14.25V14.25ZM10.4998 2.25V3.75H13.1923L5.81982 11.1225L6.87732 \n                    12.18L14.2498 4.8075V7.5H15.7498V2.25H10.4998Z",
      fill: $props.color
    }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1))]),
    _: 1
  });
}